import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const sleephealth = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
